import { stringify } from "csv-stringify/sync";

/**
 * @param bom - Prefix a UTF-8 byte order mark so Excel reads accented characters correctly
 */
export function exportDataToCsv(
  filename: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<any>,
  header: boolean = true,
  bom: boolean = false,
): void {
  const output = stringify(data, { header, bom });
  const blob = new Blob([output], { type: "text/csv" });
  const e = document.createEvent("MouseEvents"),
    a = document.createElement("a");
  a.download = filename;
  a.href = window.URL.createObjectURL(blob);
  a.dataset.downloadurl = ["text/csv", a.download, a.href].join(":");
  e.initEvent("click", true, false);
  a.dispatchEvent(e);
}
